/* SD15 product-page signals. Read-only, variant-specific, no invented counts. */
(function () {
  'use strict';
  if (window.SD15ProductSignalsLoaded) return;
  window.SD15ProductSignalsLoaded = true;
  var TTL = 60000;
  var copy = {
    en: {low: 'Low stock for this selection.', lowDefault: 'Low stock.', detail: 'Make it yours while it is available.', fresh: 'Fresh arrival. Make it yours.'},
    ar: {low: 'الكمية المتبقية قليلة من هالخيار.', lowDefault: 'الكمية المتبقية قليلة.', detail: 'اطلبه قبل ما يخلص.', fresh: 'وصل جديد. خليه إلك.'}
  };
  function setText(node, value) { if (node.textContent !== value) node.textContent = value; }
  function init() {
    var source = document.getElementById('sd15-product-signal-source');
    var root = document.querySelector('#PageContainer .ptContainer[data-section-type="product"]');
    if (!source || !root || root.sd15SignalDispose || !window.fetch || !window.AbortController) return;
    var sectionId = root.dataset.sectionId;
    var master = root.querySelector('[id="ProductSelect-' + sectionId + '"]');
    var form = master && master.closest('form');
    var title = root.querySelector('.product-single__title');
    var selection = root.querySelector('.sd-pdp-selection');
    var data = document.getElementById('ProductJson-' + sectionId);
    var badgeTemplate = source.querySelector('template[data-sd15-badge-template]');
    var messageTemplate = source.querySelector('template[data-sd15-message-template]');
    if (!form || !title || !selection || !data || !badgeTemplate || !messageTemplate) return;
    var product;
    try { product = JSON.parse(data.textContent); } catch (_) { return; }
    if (!product || String(product.id) !== source.dataset.product || !Array.isArray(product.variants)) return;
    var text = copy[source.dataset.language] || copy.en;
    var badge = badgeTemplate.content.firstElementChild.cloneNode(true);
    var message = messageTemplate.content.firstElementChild.cloneNode(true);
    if (source.dataset.language === 'ar') { badge.dir = 'rtl'; message.dir = 'rtl'; }
    title.before(badge);
    selection.appendChild(message);
    var headline = message.querySelector('[data-sd15-text]');
    var detail = message.querySelector('[data-sd15-detail]');
    var removers = [], observers = [];
    var controller = null, debounce = 0, expiry = 0, badgeExpiry = 0, timeout = 0;
    var sequence = 0, payload = null, receivedAt = 0, forcePending = false, disposed = false;
    var hasOptions = !product.variants.every(function (variant) { return variant.title === 'Default Title'; });
    function listen(node, event, fn) {
      node.addEventListener(event, fn);
      removers.push(function () { node.removeEventListener(event, fn); });
    }
    function selectedId() {
      var selectors = Array.from(form.querySelectorAll('select.single-option-selector'));
      var variant;
      if (selectors.length) {
        variant = product.variants.find(function (item) {
          return Array.isArray(item.options) && item.options.length === selectors.length && selectors.every(function (select, index) {
            var match = (select.dataset.index || '').match(/^option([1-3])$/);
            return String(item.options[match ? Number(match[1]) - 1 : index]) === select.value;
          });
        });
      } else {
        variant = product.variants.find(function (item) { return String(item.id) === master.value; });
      }
      // Do not guess when the option controls and submitted variant disagree.
      return variant && String(variant.id) === master.value ? String(variant.id) : null;
    }
    function hide() { badge.hidden = true; message.hidden = true; }
    function render() {
      if (disposed || !root.isConnected || !payload || !payload.enabled || payload.variant !== selectedId()) { hide(); return; }
      var elapsed = Math.max(0, performance.now() - receivedAt);
      var now = payload.serverNow + elapsed / 1000;
      var isNew = payload.newUntil > now;
      var fresh = elapsed < TTL;
      badge.hidden = !isNew;
      if (fresh && payload.available && payload.low) {
        setText(headline, hasOptions ? text.low : text.lowDefault);
        setText(detail, text.detail);
        message.hidden = false;
      } else if (fresh && payload.available && isNew) {
        setText(headline, text.fresh);
        setText(detail, '');
        message.hidden = false;
      } else { message.hidden = true; }
    }
    function refresh(force) {
      if (disposed || !root.isConnected || document.hidden) return;
      var variantId = selectedId();
      if (!variantId) { hide(); return; }
      if (!force && payload && payload.variant === variantId && performance.now() - receivedAt < 15000) { render(); return; }
      var requestSequence = ++sequence;
      if (controller) controller.abort();
      clearTimeout(timeout);
      controller = new AbortController();
      var currentController = controller;
      hide();
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.delete('sections[]');
      url.searchParams.set('section_id', 'sd15-product-signals');
      url.searchParams.set('variant', variantId);
      url.searchParams.set('_sd15_check', String(Date.now()));
      timeout = setTimeout(function () { currentController.abort(); }, 8000);
      fetch(url.href, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'text/html'}, signal: currentController.signal})
        .then(function (response) {
          if (!response.ok) throw new Error('Signal response unavailable');
          return response.text();
        })
        .then(function (html) {
          if (disposed || requestSequence !== sequence || variantId !== selectedId()) return;
          var documentFragment = new DOMParser().parseFromString(html, 'text/html');
          var result = documentFragment.querySelector('template[data-sd15-payload]');
          if (!result || result.dataset.product !== source.dataset.product || result.dataset.variant !== variantId) throw new Error('Signal identity mismatch');
          var serverNow = Number(result.dataset.serverNow);
          var newUntil = Number(result.dataset.newUntil);
          if (!Number.isFinite(serverNow) || serverNow <= 0 || !Number.isFinite(newUntil) || newUntil < 0 || newUntil > serverNow + 1209600) throw new Error('Invalid signal timestamp');
          payload = {enabled: result.dataset.enabled === 'true', variant: variantId, available: result.dataset.available === 'true', low: result.dataset.low === 'true', serverNow: serverNow, newUntil: newUntil};
          receivedAt = performance.now();
          clearTimeout(expiry);
          clearTimeout(badgeExpiry);
          expiry = setTimeout(render, TTL + 20);
          if (newUntil > serverNow) badgeExpiry = setTimeout(render, (newUntil - serverNow) * 1000 + 20);
          render();
        })
        .catch(function () {
          if (!disposed && requestSequence === sequence) { payload = null; hide(); }
        })
        .finally(function () {
          if (requestSequence === sequence) { clearTimeout(timeout); controller = null; }
        });
    }
    function queue(force) {
      if (disposed) return;
      hide();
      sequence += 1;
      if (controller) { controller.abort(); controller = null; }
      clearTimeout(timeout);
      clearTimeout(debounce);
      forcePending = forcePending || force === true;
      debounce = setTimeout(function () { var required = forcePending; forcePending = false; refresh(required); }, 120);
    }
    function onOptions(event) {
      if (event.target.matches('.single-option-selector,.swatchInput,select[name="id"],input[name="id"]')) queue(false);
    }
    listen(form, 'change', onOptions);
    listen(form, 'input', onOptions);
    listen(window, 'focus', function () { queue(true); });
    listen(window, 'pageshow', function (event) { if (event.persisted) queue(true); });
    listen(document, 'visibilitychange', function () {
      if (document.hidden) {
        sequence += 1;
        if (controller) { controller.abort(); controller = null; }
        clearTimeout(timeout); clearTimeout(debounce); hide();
      } else { queue(true); }
    });
    listen(root, 'variantChange', function () { queue(false); });
    // Observe only existing selection labels, not the entire page or our own output.
    ['[data-sd-selection]', '[data-sd-availability]'].forEach(function (selector) {
      var node = selection.querySelector(selector);
      if (!node) return;
      var observer = new MutationObserver(function () { queue(false); });
      observer.observe(node, {childList: true, subtree: true, characterData: true});
      observers.push(observer);
    });
    if (window.jQuery) {
      var namespace = '.sd15Signals' + sectionId.replace(/[^a-z0-9]/gi, '');
      window.jQuery(root).on('variantChange' + namespace, function () { queue(false); });
      window.jQuery(document).on('cart.requestComplete' + namespace, function () { queue(true); });
      removers.push(function () { window.jQuery(root).off(namespace); window.jQuery(document).off(namespace); });
    }
    root.sd15SignalDispose = function () {
      disposed = true; sequence += 1;
      if (controller) controller.abort();
      [debounce, expiry, badgeExpiry, timeout].forEach(clearTimeout);
      observers.forEach(function (observer) { observer.disconnect(); });
      removers.forEach(function (remove) { remove(); });
      badge.remove(); message.remove(); delete root.sd15SignalDispose;
    };
    queue(true);
  }
  function ready() { setTimeout(init, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
  window.addEventListener('load', ready, {once: true});
  document.addEventListener('shopify:section:load', ready);
  document.addEventListener('shopify:section:unload', function (event) {
    var root = document.querySelector('#PageContainer .ptContainer[data-section-type="product"]');
    if (root && root.sd15SignalDispose && (event.target === root || event.target.contains(root))) root.sd15SignalDispose();
  });
})();
